<template>
  <div class="dialog-container">
    <el-dialog :visible="dialogDataGetter" :show-close="false">
      <!-- 登录 -->
      <div v-if="dialogTypeGetters == 'login'">
        <div class="login-box">
          <div class="close clearfix" @click="close">
            <img src="@/assets/close.png" alt />
          </div>
          <div class="main">
            <div class="title">用户登录</div>
            <input type="text" class="tagWrap" placeholder="手机号" v-model="login.phone" />
            <input type="password" class="tagWrap" placeholder="密码" v-model="login.pwd" />
            <div class="group">
              <div class="wrap">
                <el-checkbox v-model="rememberMe">记住我</el-checkbox>
              </div>
              <span class="word pointer" @click="jumpForget">忘记密码</span>
            </div>
            <el-button
              class="login"
              type="primary"
              :disabled="!login.phone || !login.pwd"
              @click="handleLogin"
            >登录</el-button>
            <div class="outer">
              <span class="info">还没有账户？马上</span>
              <span class="word_2" @click="jumpRegister">注册</span>
            </div>
          </div>
          <!-- <div class="ft">
                    因平台升级，如遇密码错误无法登录请通过“忘记密码”找回
          </div>-->
        </div>
      </div>
      <!-- 注册 -->
      <div v-else-if="dialogTypeGetters == 'join'">
        <div class="join-box">
          <div class="close clearfix" @click="close">
            <img src="@/assets/close.png" alt />
          </div>
          <div class="main">
            <div class="title">登录</div>
            <input type="text" class="tagWrap" placeholder="手机号" v-model="registered.phone" />
            <!-- <input type="password" class="tagWrap" placeholder="密码(6-20位数字或字母)" v-model="registered.pwd"> -->
            <div class="code-box">
              <input type="text" class="tagWrap" placeholder="短信验证码" v-model="registered.code" />
              <el-button class="code-btn" v-if="sending" @click="handleSendCode">发送验证码</el-button>
              <el-button class="code-btn code-btn-disabled" v-if="!sending">{{second}}s</el-button>
            </div>

            <div class="group">
              <!-- <div class="wrap">
                        <el-checkbox v-model="acceptMe">我已经接受 <span class="protocol" @click="goProtocol">《注册协议》</span> </el-checkbox>
              </div>-->
              <!-- <span class="word" >忘记密码</span> -->
            </div>
            <el-button class="login" type="primary" @click="handleRegistered">登录</el-button>
            <!-- <div class="outer">
                    <span class="info" >已有账号？请直接</span>
                    <span class="word_2" @click="jumpLogin">登录</span>
            </div>-->
          </div>
        </div>
      </div>
      <!-- 忘记密码 -->
      <div v-else-if="dialogTypeGetters == 'forget'">
        <div class="join-box">
          <div class="close clearfix" @click="close">
            <img src="@/assets/close.png" alt />
          </div>
          <div class="main">
            <div class="title">找回密码</div>
            <input type="text" class="tagWrap" placeholder="手机号" v-model="forget.phone" />
            <input
              type="password"
              class="tagWrap"
              placeholder="密码(6-20位数字或字母)"
              v-model="forget.pwd"
            />
            <div class="code-box">
              <input type="text" class="tagWrap" placeholder="短信验证码" v-model="forget.code" />
              <el-button class="code-btn" v-if="sendingForget" @click="handleSendCodeForget">发送验证码</el-button>
              <el-button class="code-btn code-btn-disabled" v-if="!sendingForget">{{secondForget}}s</el-button>
            </div>
            <div class="group">
              <div class="wrap">&nbsp;</div>
            </div>
            <el-button class="login" type="primary" @click="handleForget">确认</el-button>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters, mapMutations } from "vuex";
import { getCookie, setCookie, delCookie } from "../../util/rememberMe.js";
import { newVue, check } from "@/util/check";
import bus from "@/common/bus";
import {
  getCode,
  smsLogin,
  setLogin,
  setForgetPassword,
  getGradeList
} from "@/servers/api";
export default {
  data() {
    return {
      // 防抖 3秒钟
      stopTime: 5000,
      codeBtn: false, // 验证码
      codeForgetBtn: false, // 验证码
      registerBtn: false, // 注册
      loginBtn: false, // 登录
      forgetBtn: false, // 忘记密码

      constants: {},
      rememberMe: false, // 记住我
      acceptMe: false, // 我已接受
      tel: "",
      code: "",
      // 注册
      registered: {
        phone: "",
        pwd: "",
        code: ""
      },
      // 登录
      login: {
        phone: "",
        pwd: ""
      },
      // 忘记密码
      forget: {
        phone: "",
        pwd: "",
        code: ""
      },
      // 是否可以点击验证码
      sending: true,
      sendingForget: true,
      // 倒计时
      second: 60,
      secondForget: 60,
      // 验证码
      code: "",
      codeForget: "",
      // reg
      telReg: /^[1][3,4,5,6,7,8,9][0-9]{9}$/,
      // tip
      tipMsg: {
        phoneRequire: "请输入手机号",
        phoneCorrect: "请输入合法的手机号",
        codeSend: "验证码已发送",
        pwdRequire: "请输入密码",
        codeRequire: "请输入验证码",
        codeCorrect: "验证码不正确,请重新输入",
        registerSuccess: "注册成功，请登录",
        forgetSuccess: "修改密码成功，请登录",
        loginSuccess: "登录成功",
        acceptMe: "请接受注册协议"
      },
      data: [
      {
        name: "小学",
        id: 3,
        children: [
          {
            name: "1年级",
            id: 1,
          },
          {
            name: "2年级",
            id: 2,
          },
          {
            name: "3年级",
            id: 3,
          },
          {
            name: "4年级",
            id: 4,
          },
          {
            name: "5年级",
            id: 5,
          },
          {
            name: "6年级",
            id: 6,
          },
        ],
      },
      {
        name: "初中",
        id: 4,
        children: [
          {
            name: "初一",
            id: 7,
          },
          {
            name: "初三",
            id: 9,
          },
          {
            name: "初二",
            id: 8,
          },
        ],
      },
      {
        name: "高中",
        id: 5,
        children: [
          {
            name: "高一",
            id: 10,
          },
          {
            name: "高二",
            id: 11,
          },
          {
            name: "高三",
            id: 12,
          },
        ],
      },
      {
        name: "学前",
        id: 2,
        children: [
          {
            name: "0-1岁",
            id: 24,
          },
          {
            name: "3-6岁",
            id: 23,
          },
          {
            name: "1-3岁",
            id: 22,
          },
        ],
      },
      {
        name: "其他",
        id: -1,
      },
    ]
      

    };
  },
  created() {
    newVue.obj = this;
  },
  methods: {
    ...mapMutations([
      "setDialogMutations",
      "dialogTypeMutations",
      "setLoginUrl",
      "changeLoginInfo"
    ]),
    chooseSchool(item) {

    },
    close() {
      this.setDialogMutations(false);
    },
    // 跳转注册
    jumpRegister() {
      this.dialogTypeMutations("join");
      this.setDialogMutations(true);
    },
    // 跳转登录
    jumpLogin() {
      this.dialogTypeMutations("login");
      this.setDialogMutations(true);
    },
    // 跳转忘记密码
    jumpForget() {
      this.dialogTypeMutations("forget");
      this.setDialogMutations(true);
    },
    // 跳转注册协议
    goProtocol() {
      const { href } = this.$router.resolve({
        path: "/agreement"
      });
      window.open(href, "_blank");
    },
    // 登录
    async handleLogin() {
      if (!this.login.phone) {
        this.$Toast({
          content: this.tipMsg.phoneRequire,
          type: "error"
        });
        return false;
      }
      if (!this.telReg.test(this.login.phone)) {
        this.$Toast({
          content: this.tipMsg.phoneCorrect,
          type: "error"
        });
        return false;
      }
      if (!this.login.pwd) {
        this.$Toast({
          content: this.tipMsg.pwdRequire,
          type: "error"
        });
        return false;
      }

      if (this.loginBtn === false) {
        this.loginBtn = true;
        setTimeout(() => {
          this.loginBtn = false;
        }, this.stopTime);
        // 接口请求
        const params = {
          ...this.login
        };
        const res = await setLogin(params);
        if (res.code == 0) {
          if (this.rememberMe) {
            setCookie("login", JSON.stringify(this.login), 7);
          }

          localStorage.setItem("token", res.data);
          this.$Toast({
            content: this.tipMsg.loginSuccess,
            type: "success"
          });
          bus.$emit("loginRandom", Math.random());
          if (this.loginUrlGetter.path) {
            this.$router.push({
              path: this.loginUrlGetter.path,
              query: { ...this.loginUrlGetter.query }
            });
            this.setLoginUrl({
              path: "",
              query: {}
            });
          }
          this.close();
        } else if (res.code == 1001) {
          this.$Toast({
            content: res.msg,
            type: "error"
          });
        }
      }
    },
    // 验证码登录
    async handleRegistered() {
      if (!this.registered.phone) {
        this.$Toast({
          content: this.tipMsg.phoneRequire,
          type: "error"
        });
        return false;
      }
      if (!this.telReg.test(this.registered.phone)) {
        this.$Toast({
          content: this.tipMsg.phoneCorrect,
          type: "error"
        });
        return false;
      }
      // if (!this.registered.pwd) {
      //   this.$Toast({
      //     content: this.tipMsg.pwdRequire,
      //     type:'error',
      //   });
      //   return false
      // }
      // let result = check.checkPwValidate(this.registered.pwd);
      // if (!result) {
      //   return false
      // }
      if (!this.registered.code) {
        this.$Toast({
          content: this.tipMsg.codeRequire,
          type: "error"
        });
        return false;
      }
      // if (this.registered.code != this.code) {
      //   this.$Toast({
      //     content: this.tipMsg.codeCorrect,
      //     type:'error',
      //   });
      //   return false
      // }
      // if (!this.acceptMe) {
      //   this.$Toast({
      //     content: this.tipMsg.acceptMe,
      //     type:'error',
      //   });
      //   return false
      // }

      if (this.registerBtn === false) {
        this.registerBtn = true;
        setTimeout(() => {
          this.registerBtn = false;
        }, this.stopTime);
        // 接口请求
        // const params = {
        //   ...this.registered
        // }
        const params = {
          code: this.registered.code,
          mobile: this.registered.phone
          // parent_id: this.$route.query.uid,
        };
        const res = await smsLogin(params);
        if (res.errcode == 0) {
          this.close();
          this.$Toast({
            content: "登录成功",
            type: "success"
          });
          // 登录成功后判断是否选择过兴趣分类
          localStorage.setItem("Auth", JSON.stringify(res.data));
          this.changeLoginInfo({
            status: true,
            name: ""
          });
          this.changeLoginInfo({
            status: true,
            name: res.data.username
          });
          this.$router.push({
            path: "/my",
            query: {}
          });
          getGradeList()
            .then(success => {
              if (success && success.data && success.data.length == 0) {
                // this.$router.push({
                //   path: "/chooseCategory",
                //   query: {
                //     // id: this.id,
                //   },
                // });
              } else {
                // this.loginLoading = false;
                // if (this.$route.query.redirect) {
                //   this.$router.push({
                //     path: this.$route.query.redirect.toString(),
                //     query: {
                //       // id: this.id,
                //     },
                //   });
                // } else {
                //   this.$router.push({
                //     path: "/",
                //     query: {
                //       // id: this.id,
                //     },
                //   });
                // }
              }
            })
            .catch(() => {});
          // this.login.phone = this.registered.phone
          // this.login.pwd = this.registered.pwd
          // this.handleLogin()
        }
      }
    },
    // 找回密码
    async handleForget() {
      if (!this.forget.phone) {
        this.$Toast({
          content: this.tipMsg.phoneRequire,
          type: "error"
        });
        return false;
      }
      if (!this.telReg.test(this.forget.phone)) {
        this.$Toast({
          content: this.tipMsg.phoneCorrect,
          type: "error"
        });
        return false;
      }
      if (!this.forget.pwd) {
        this.$Toast({
          content: this.tipMsg.pwdRequire,
          type: "error"
        });
        return false;
      }
      let result = check.checkPwValidate(this.forget.pwd);
      if (!result) {
        return false;
      }
      if (!this.forget.code) {
        this.$Toast({
          content: this.tipMsg.codeRequire,
          type: "error"
        });
        return false;
      }
      // if (this.forget.code != this.codeForget) {
      //   this.$Toast({
      //     content: this.tipMsg.codeCorrect,
      //     type:'error',
      //   });
      //   return false
      // }

      if (this.forgetBtn === false) {
        this.forgetBtn = true;
        setTimeout(() => {
          this.forgetBtn = false;
        }, this.stopTime);
        // 接口请求
        const params = {
          phone: this.forget.phone,
          newPwd: this.forget.pwd,
          smsCode: this.forget.code
        };
        const res = await setForgetPassword(params);
        if (res.code == 0) {
          // this.$Toast({
          //   content: this.tipMsg.forgetSuccess,
          //   type:'success',
          // });
          delCookie("login");
          this.login.phone = this.forget.phone;
          this.login.pwd = this.forget.pwd;
          this.handleLogin();
        } else if (res.code == 1001) {
          this.$Toast({
            content: res.msg,
            type: "error"
          });
          delCookie("login");
        }
      }
    },
    // 验证码
    async handleSendCode() {
      if (!this.registered.phone) {
        this.$Toast({
          content: this.tipMsg.phoneRequire,
          type: "error"
        });
        return false;
      }
      if (!this.telReg.test(this.registered.phone)) {
        this.$Toast({
          content: this.tipMsg.phoneCorrect,
          type: "error"
        });
        return false;
      }

      if (this.codeBtn === false) {
        this.sending = false;
        this.timeDown();
        this.codeBtn = true;
        setTimeout(() => {
          this.codeBtn = false;
        }, this.stopTime);
        // 接口请求
        const params = {
          mobile: this.registered.phone
        };

        const res = await getCode(params);
        if (res.code == 0) {
          console.log("code", res);
          this.code = res.data;
          this.$Toast({
            content: this.tipMsg.codeSend,
            type: "success"
          });
        }
      }
    },
    // 找回密码验证码
    async handleSendCodeForget() {
      if (!this.forget.phone) {
        this.$Toast({
          content: this.tipMsg.phoneRequire,
          type: "error"
        });
        return false;
      }
      if (!this.telReg.test(this.forget.phone)) {
        this.$Toast({
          content: this.tipMsg.phoneCorrect,
          type: "error"
        });
        return false;
      }

      if (this.codeForgetBtn === false) {
        this.sendingForget = false;
        this.timeDownForget();
        this.codeForgetBtn = true;
        setTimeout(() => {
          this.codeForgetBtn = false;
        }, this.stopTime);
        // 接口请求
        const params = {
          phone: this.forget.phone
        };
        const res = await getCode(params);
        if (res.code == 0) {
          this.codeForget = res.data;
          this.$Toast({
            content: this.tipMsg.codeSend,
            type: "success"
          });
        }
      }
    },
    // 倒计时
    timeDown() {
      let result = setInterval(() => {
        --this.second;
        if (this.second < 0) {
          clearInterval(result);
          this.sending = true;
          this.second = 60;
        }
      }, 1000);
    },
    // 倒计时
    timeDownForget() {
      let result = setInterval(() => {
        --this.secondForget;
        if (this.secondForget < 0) {
          clearInterval(result);
          this.sendingForget = true;
          this.secondForget = 60;
        }
      }, 1000);
    }
  },
  computed: {
    ...mapGetters(["dialogTypeGetters", "dialogDataGetter", "loginUrlGetter"])
  },
  watch: {
    dialogDataGetter(newVal) {
      if (newVal == false) {
        this.registered = {
          phone: "",
          pwd: "",
          code: ""
        };
        this.login = {
          phone: "",
          pwd: ""
        };
        this.forget = {
          phone: "",
          pwd: "",
          code: ""
        };
        this.rememberMe = false;
        this.acceptMe = false;
      } else {
        if (getCookie("login")) {
          this.login = JSON.parse(decodeURIComponent(getCookie("login")));
        }
      }
    }
  },
  mounted() {}
};
</script>
<style src="./index.css" />
<style scoped lang="less">
.dialog-container {
  .pointer {
    cursor: pointer;
  }
  .protocol {
    &:hover {
      color: #09f;
    }
  }
  /* 登录 */
  .login-box {
    position: relative;
    .close {
      position: absolute;
      right: 20px;
      top: 20px;
      cursor: pointer;
    }
    .close img {
      width: 18px;
    }
    .main {
      width: 440px;
      background-color: #ffffff;
      border-radius: 18px;
      text-align: center;
      padding-bottom: 40px;
      .title {
        height: 33px;
        font-weight: 400;
        font-size: 24px;
        color: #333333;
        line-height: 33px;
        width: 260px;
        margin: 0px auto;
        padding-top: 40px;
        overflow: hidden;
        text-overflow: ellipsis;
        letter-spacing: 2px;
        white-space: nowrap;
      }

      .tagWrap {
        margin-top: 31px;
        padding-right: 20px;
        padding-left: 30px;
        width: 308px;
        height: 44px;
        background: rgba(248, 248, 248, 1);
        border-radius: 22px;
        height: 44px;
        position: static;
        background-color: #f8f8f8;
        border-radius: 22px;
        box-sizing: border-box;
        border: none;
      }
      .code-box {
        width: 308px;
        height: 44px;
        position: relative;
        margin: 0 auto;
        .code-btn {
          right: 0;
          top: 31px;
          position: absolute;
          width: 104px;
          height: 44px;
          background: #fbc51d;
          border-radius: 22px;
          border: none;
          font-size: 14px;
          color: #ffffff;
        }
      }
    }
  }
  /* 注册 */
  .join-box {
    position: relative;
    .close {
      position: absolute;
      right: 20px;
      top: 20px;
      cursor: pointer;
      img {
        width: 18px;
      }
    }
    .main {
      width: 440px;
      background-color: #ffffff;
      border-radius: 18px;
      text-align: center;
      padding-bottom: 40px;
      .title {
        height: 33px;
        font-weight: 400;
        font-size: 24px;
        color: #333333;
        line-height: 33px;
        width: 260px;
        margin: 0px auto;
        padding-top: 40px;
        overflow: hidden;
        text-overflow: ellipsis;
        letter-spacing: 2px;
        white-space: nowrap;
      }

      .tagWrap {
        margin-top: 31px;
        padding-right: 20px;
        padding-left: 30px;
        width: 308px;
        height: 44px;
        background: rgba(248, 248, 248, 1);
        border-radius: 22px;
        height: 44px;
        position: static;
        background-color: #f8f8f8;
        border-radius: 22px;
        box-sizing: border-box;
        border: none;
      }
      .code-box {
        width: 308px;
        height: 44px;
        position: relative;
        margin: 0 auto;
        .code-btn {
          right: 0;
          top: 31px;
          position: absolute;
          width: 104px;
          height: 44px;
          background: #fbc51d;
          border-radius: 22px;
          border: none;
          font-size: 14px;
          color: #ffffff;
        }
        .code-btn-disabled {
          background-color: #d8d8d8;
        }
      }
    }
  }
  /* grade */
  .grade-container {
    text-align: center;
    overflow: hidden;
    /* padding-top: 50px; */
    .close {
      position: absolute;
      right: 15px;
      top: 10px;
      cursor: pointer;
    }
    .title {
      margin-top: 50px;
      font-size: 26px;
    }
    .school-box {
      width: 360px;
      margin: 50px auto 0;
      height: 220px;
      overflow: hidden;
      .school-item {
        float: left;
        margin-left: 10px;
        margin-top: 20px;
        cursor: pointer;
        font-size: 24px;
        padding-left: 20px;
        padding-right: 20px;
        border: 1px solid #777777;
        border-radius: 20px;
      }
    }
    .des {
      margin-top: 10px;
    }
  }
}
</style>
